import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import A4SO from "./a4SO";
import ThermalSO from "./ThermalSO";
import Barcode from "react-barcode";
import { PrinterOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import SOA5 from "./a5SO";
import { Button } from "antd";
import { get_sales_order } from "../../../../Controllers/Sales/SO";
import Header from "../../../../Componets/Header";
import headers from "../../../../Data/Forms/Sales/SO/heders";
import Loadercomponent from "../../../../Componets/Loader";
import SOA5Header from "./a5SOHeader";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";

const SOView = (props) => {
  let { id } = useParams();

  const soA4Ref = useRef();
  const soRef = useRef();
  const soA5Ref = useRef();
  const soA5HeaderRef = useRef();

  const handleA4Print = useReactToPrint({
    content: () => soA4Ref.current,
  });

  const handlePrint = useReactToPrint({
    content: () => soRef.current,
  });

  const handleA5Print = useReactToPrint({
    content: () => soA5Ref.current,
  });
  const handleA5HeaderPrint = useReactToPrint({
    content: () => soA5HeaderRef.current,
  });

  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState();
  const [header, setHeader] = useState(headers);

  const handleData = (so) => {
    const updatedso = { ...so };
    setValues(updatedso);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const so = await get_sales_order(data);

      console.log("billing", so);

      if (so?.status) {
        handleData(so?.data);
      } else {
        toast?.error(so?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader}>
      <Loadercomponent loader={loader}>
        <ScrollWrapper>
          <div className="pb-8">
            <div className="flex justify-end">
              <div className="p-2" onClick={handleA4Print}>
                <Button size="large">
                  A4 Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
              <div className="pt-2 " onClick={handlePrint}>
                <Button size="large">
                  Thermal Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
              <div className="p-2" onClick={handleA5Print}>
                <Button size="large">
                  A5 Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
              <div className="p-2" onClick={handleA5HeaderPrint}>
                <Button size="large">
                  A5 Header Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
            </div>
          </div>

          <div>
            <A4SO ref={soA4Ref} values={values} />
          </div>

          <div className="hidden-on-screen">
            <ThermalSO ref={soRef} values={values} />
          </div>

          <div className="hidden-on-screen">
            <SOA5 ref={soA5Ref} values={values} />
          </div>

          <div className="hidden-on-screen">
            <SOA5Header ref={soA5HeaderRef} values={values} />
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default SOView;
